import { CommonService } from 'app/services/common.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';



@Component({
  selector: 'app-message-file-upload',
  templateUrl: './message-file-upload.component.html',
  styleUrls: ['./message-file-upload.component.scss']
})
export class MessageFileUploadComponent implements OnInit, OnDestroy {
  @ViewChild('fileNameContainer') fileNameContainer: ElementRef;
  @Input() fileUploadMessageInstance;
  @Input() file: any;
  @Input() categories = [];
  @Input() disabled;
  @Input() resetFileOptions;
  @Output('fileUploadMessageResponse')  fileUploadMessageResponse: EventEmitter<any> = new EventEmitter<any>();
  @Output('deleteFileResponse') deleteFileResponse: EventEmitter<any> = new EventEmitter<any>();
  @Output() removeFile = new EventEmitter<any>();
  @Output() fileCategoryChange = new EventEmitter<any>();
  categoryType = '0';
  selectedCategoryName = '';
  selectedCategoryId;
  multipleFileArray = [];
  coachUserId;
  fileName = '';
  roleName;
  deleteButtonFlag = false;
  fileNameWidth: number;
  removeResizeListener: Function;

  constructor (
    private _commonAuthService: CommonAuthenticationService,
    private _commonService: CommonService,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.roleName = this._commonAuthService.getModule().toLowerCase();
    this.getFileNameWidth();
    this.removeResizeListener = this.renderer.listen('window', 'resize', () => {
      this.getFileNameWidth();
    });
  }

  onChange(categoryOptions) {
    this.selectedCategoryName = categoryOptions.options[categoryOptions.selectedIndex].text;
    this.selectedCategoryId = this.categories.map((data: any) => data.text === this.selectedCategoryName ? data.value : '').filter(function (e) { return e !== '' }).toString();
    this.fileCategoryChange.emit(this.selectedCategoryId);
  }

  fileChangeEvent(e) {
    this.multipleFileArray = [];
    this._commonService.chooseFileEvent(e[0]).Ok((data: any) => {
      this.fileUploadMessageInstance.fileName = data.fileName;
      this.multipleFileArray.push(data);
    })
  }

  uploadFile() {
    this.fileUploadMessageInstance.attachmentData = {
      fileData: this.multipleFileArray ,
      selectedCategory : this.selectedCategoryName,
      selectedCategoryId : this.selectedCategoryId
    };

    this.fileUploadMessageInstance.disable = true;
    this.deleteButtonFlag = true;
    this.fileUploadMessageInstance.uploaded = true;
    this.fileUploadMessageResponse.emit(this.fileUploadMessageInstance);
  }

  getFileNameWidth() {
    this.fileNameWidth = this.fileNameContainer.nativeElement.offsetWidth * 0.85;
  }

  ngOnDestroy() {
    this.removeResizeListener();
  }
}
